module.exports = __webpack_public_path__ + "img/profil_perso.cdee9cf3.jpg";